import BlockNews from "../BlockNews/BlockNews";
import React from "react";
import {GET_NEWS_INDEX} from "../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function GetNewsIndex (props) {
    const { loading, error, data} = useQuery(GET_NEWS_INDEX, {variables : { ContestName : props.ContestName }});
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;
    const ToNewArray2 = data.getNewsIndex.map(function(document) {
        let MyAlldate = document.NewsDate.split('-');
        let MyYear = MyAlldate[0];
        let MyMonth = MyAlldate[1];
        let MyDate = MyAlldate[2];
        return [JSON.parse(document.Title.split("'").join(''))[props.lang], MyYear, MyMonth, MyDate, MyAlldate, JSON.parse(document.TextForMain.split("'").join(''))[props.lang], document._id, document.DopInfo]
    }).sort(function(a, b){return b[4] - a[4]});
    return <BlockNews lang={props.lang} ArrayNews={ToNewArray2}  data={props.data}/>}
export default GetNewsIndex